import React, { useState } from 'react'
import Bredcrumb from '../Common/Bredcrumb'
import { } from 'react-router-dom'
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
const FresherParty = () => {

    const images = [
        'img/content/events-01.png',
        'img/content/events-02.png',
        'img/content/events-03.png',
        'img/content/events-04.png',
        'img/content/events-05.png',
        'img/content/events-06.png',
        'img/content/events-07.png',
        'img/content/events-08.png',
        'img/content/events-09.png',
        'img/content/events-10.png',
        'img/content/events-11.png',
        'img/content/events-12.png',
        'img/content/events-13.png',
        'img/content/events-14.png',
        'img/content/events-15.png',
        'img/content/events-16.png',
        'img/content/events-17.png',
        'img/content/events-18.png',
        'img/content/events-19.png',
        'img/content/events-20.png',
        'img/content/events-21.png',
        'img/content/events-22.png',
        'img/content/events-23.png',
        'img/content/events-24.png',
       ];
    
      const [isOpen, setIsOpen] = useState(false);
      const [photoIndex, setPhotoIndex] = useState(0);
      const [loading, setLoading] = useState(false);
    
      const openLightbox = (index) => {
        setPhotoIndex(index);
        setIsOpen(true);
        setLoading(true);
      };
    
      const closeLightbox = () => {
        setIsOpen(false);
        setLoading(false);
      };
    
      const onImageLoad = () => {
        setLoading(false);
      };

      
  return (
    <>
      <Bredcrumb title="Fresher Party" />
      <section className="facility-box mt-4">
        <div className="container">          
          <div className="row mb-4">
                    <div className="col-md-12">
                            <div className="gallery text-center row">
                            {images.map((image, index) => (
                            <div key={index} className="col-md-4 mb-4">
                                <div className='gallery-block'>
                                    <img src={image} alt={`Image ${index + 1}`} onClick={() => openLightbox(index)} style={{cursor: 'pointer' }} />
                                </div>
                            </div>
                            ))}
                            {isOpen && (
                                <Lightbox
                                    mainSrc={images[photoIndex]}
                                    nextSrc={images[(photoIndex + 1) % images.length]}
                                    prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                                    onCloseRequest={closeLightbox}
                                    onMovePrevRequest={() => setPhotoIndex((photoIndex + images.length - 1) % images.length)}
                                    onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % images.length)}
                                    imageLoadErrorHandler={() => setLoading(false)}
                                    onImageLoad={onImageLoad}
                                />
                            )}
                            {loading && <div className="loading-indicator">Loading...</div>}

                        
                            </div>
                    </div>
                </div>	           
          </div>
        </section>
    </>
  )
}

export default FresherParty
